import { AppointmentStatus } from "../simple/appointment-status.enum";



export class DigitalcouponRequestSearch {
    address: string;
    appointmentDate: string;
    appointmentStatus: AppointmentStatus;
    city: string;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    storeId: number;
    topicId: number;
    reservationDate: string;
    start: string;
    end: string;
    q:string;
    
}



export class DigitalcouponRequestExportCsv {
    appointmentDateFrom: string;
    appointmentDateTo: string;
    status: AppointmentStatus;
    storeAddress: string;
    storeCity: string;
    
  }